import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SportsThemedButtonDirective } from '@frontend/sports/common/ui/sports-themed-button';
import { DsButton } from '@frontend/ui/button';
import { EffectsModule } from '@ngrx/effects';

import { ShowInEpcotDirective } from '../../../lib/common/epcot-config.directive';
import { OverAskModule } from '../over-ask/over-ask.module';
import { TeaserBetPlaceButtonStateService } from '../teaser-bet/services/place-button/teaser-bet-place-button-state.service';
import { PlaceButtonComponent } from './components/digital/place-button.component';
import NotificationEffects from './effects/notification-effects';
import { PlaceBetLoggerEffects } from './effects/place-bet-balance-logger.effect';
import PlaceBetEffects from './effects/place-bet-effects';
import PlaceButtonEffects from './effects/place-button-effects';
import BetBuilderPlaceBetService from './services/bet-builder-place-bet-service';
import { PlaceBetErrorMapper } from './services/place-bet-error-mapper';
import PlaceBetResponseProcessorService from './services/place-bet-response-processor.service';
import PlaceBetService from './services/place-bet.service';
import { PlaceButtonActionStateService } from './services/place-button/place-button-action-state.service';
import { PlaceButtonBaseStateService } from './services/place-button/place-button-base-state.service';
import { PlaceButtonErrorStateService } from './services/place-button/place-button-error-state.service';
import { PlaceButtonExternalStateService } from './services/place-button/place-button-external-state.service';
import { PlaceButtonMessagesProviderService } from './services/place-button/place-button-messages-provider.service';
import { PlaceButtonTrackingService } from './services/place-button/place-button-tracking.service';
import RequestIdBuilder from './services/request-id-builder';
import { EarlyPayoutRequestBuilder } from './services/request/early-payout-request-builder';
import { PickRequestMapperFactory } from './services/request/pick-request-mapper/pick-request-mapper.factory';
import PlaceBetRequestBuilder from './services/request/place-bet-request-builder';
import RegulatoryRequestStrategy from './services/request/strategies/regulatory-request-strategy';
import { REQUEST_STRATEGIES_INJECTION_TOKEN } from './services/request/strategies/request-strategies';
import RewardTokensRequestStrategy from './services/request/strategies/reward-tokens-request-strategy';
import { TeaserBetRequestStrategy } from './services/request/strategies/teaser-bet-request.strategy';

@NgModule({
    imports: [
        CommonModule,
        OverAskModule,
        EffectsModule.forFeature([PlaceBetEffects, NotificationEffects, PlaceButtonEffects, PlaceBetLoggerEffects]),
        ShowInEpcotDirective,
        DsButton,
        SportsThemedButtonDirective,
    ],
    declarations: [PlaceButtonComponent],
    exports: [PlaceButtonComponent],
    providers: [
        RequestIdBuilder,
        PlaceBetRequestBuilder,
        PlaceBetService,
        PlaceBetResponseProcessorService,
        PlaceBetErrorMapper,
        PickRequestMapperFactory,
        TeaserBetPlaceButtonStateService,
        EarlyPayoutRequestBuilder,
        BetBuilderPlaceBetService,
        // Place Button
        PlaceButtonBaseStateService,
        PlaceButtonErrorStateService,
        PlaceButtonExternalStateService,
        PlaceButtonTrackingService,
        PlaceButtonMessagesProviderService,
        PlaceButtonActionStateService,
        { provide: REQUEST_STRATEGIES_INJECTION_TOKEN, useClass: RewardTokensRequestStrategy, multi: true },
        { provide: REQUEST_STRATEGIES_INJECTION_TOKEN, useClass: TeaserBetRequestStrategy, multi: true },
        { provide: REQUEST_STRATEGIES_INJECTION_TOKEN, useClass: RegulatoryRequestStrategy, multi: true },
    ],
})
export default class BetslipDigitalBetPlacementModule {}
